import { render, staticRenderFns } from "./MessageIQTrial.vue?vue&type=template&id=7f025627&scoped=true&"
import script from "./MessageIQTrial.vue?vue&type=script&lang=js&"
export * from "./MessageIQTrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f025627",
  null
  
)

export default component.exports